// @vendors
import React from 'react'
import { Grid } from '../../../../../components/shared/MaterialUI'

// @components
import DetailCardEmployee from '../../../../../components/atoms/DetailCardEmployee'
import CardProgress from '../../../../../components/atoms/CardProgress'
import { CardBenefits } from '../../../../../components/atoms/CardBenefits'

// @helpers
import { convertDateToUTCTexas } from '../../../../../helpers/FunctionsUtils'

const CardsInformation = ({ employeeInfo }) => {
   
  return (
    <Grid
        container
        spacing={2}
        justify="center"
        sx={{ width: '100%', marginBottom: '20px' }}
    >        
        <Grid item xs={6} sm={2} md={2} lg={2} xl={2}>
            <DetailCardEmployee
            title='Created at'
            value={convertDateToUTCTexas(employeeInfo?.createdAt)}
            />
        </Grid>

        <Grid item xs={6} sm={2} md={2} lg={2} xl={2}>
            <DetailCardEmployee
            title='Origin create'
            value={employeeInfo?.originCreate ?? ''}
            />
        </Grid>
        
        {employeeInfo?.updatedBy &&
            <Grid item xs={6} sm={2} md={2} lg={2} xl={2}>
                <DetailCardEmployee
                title='Updated by'
                value={employeeInfo?.updatedBy ? employeeInfo?.updatedBy : employeeInfo?.fullName}
                />
            </Grid>
        }

        {employeeInfo?.isRehire && 
            <Grid item xs={6} sm={2} md={2} lg={2} xl={2}>
            <DetailCardEmployee
                title='Is rehire'
                value={'Potential rehire'}
                color='#FF0000'
            />
            </Grid>
        }

        {employeeInfo?.emailOptOut &&
            <Grid item xs={6} sm={2} md={2} lg={2} xl={2}>
            <DetailCardEmployee
                title='Status'
                value={'Unsubscribed'}
            />
            </Grid>
        }            

        {employeeInfo?.emailIsOnSuppresedList &&
            <Grid item xs={12} sm={3} md={3} lg={3} xl={3}>
            <DetailCardEmployee
                title='This email is on the suppressed list'
                value={employeeInfo?.reasonSuppresed ?? ''}
            />
            </Grid>
        }

        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Grid container justify="center" spacing={2}>
                <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                    <CardBenefits
                        title='Eligible groups'
                        employeeInfo={employeeInfo}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                    <CardProgress employeeInfo={employeeInfo} />
                </Grid>
            </Grid>
        </Grid>
    </Grid>
  )
}

export default CardsInformation